module.exports = __webpack_public_path__ + "static/media/11_hero_desktop.d195f97e.jpg";